import { post } from "../GenericServices";

const ProjectPlan = {
  approveProjectPlan: (id, queryString) => {
    return post(`project/${id}/project-plan?${queryString}`);
  },
};

export default ProjectPlan;
